// Optimistic UI update helper functions
function updateCartCountOptimistic(delta) {
    var cartCount = document.querySelector(".cart-link__count");

    if (delta > 0) {
        // Adding to cart
        if (cartCount) {
            var currentCount = parseInt(cartCount.textContent, 10) || 0;
            cartCount.textContent = currentCount + delta;
        } else {
            // Create cart count element if it doesn't exist
            var cartLinkIcon = document.querySelector(".cart-link__icon");
            if (cartLinkIcon) {
                var newCartCount = document.createElement("span");
                newCartCount.className = "cart-link__count";
                newCartCount.textContent = delta.toString();
                cartLinkIcon.appendChild(newCartCount);
            }
        }
    } else if (delta < 0) {
        // Removing from cart
        if (cartCount) {
            var currentCount = parseInt(cartCount.textContent, 10) || 0;
            var newCount = Math.max(0, currentCount + delta);
            if (newCount === 0) {
                cartCount.remove();
            } else {
                cartCount.textContent = newCount;
            }
        }
    }
}

function applyOptimisticUIState(checkbox, isChecked) {
    checkbox.setAttribute("data-added", isChecked ? "true" : "false");
    checkbox.checked = isChecked;

    if (isChecked) {
        checkbox.parentElement.classList.add("checked");
    } else {
        checkbox.parentElement.classList.remove("checked");
    }
}

function revertOptimisticUIState(checkbox, previousState) {
    checkbox.setAttribute("data-added", previousState.dataAdded);
    checkbox.checked = previousState.checked;

    if (previousState.checked) {
        checkbox.parentElement.classList.add("checked");
    } else {
        checkbox.parentElement.classList.remove("checked");
    }
}

// Handle checkbox change event for cross-selling with optimistic updates
document.addEventListener("change", function (event) {
    var checkbox = event.target;

    if (
        checkbox.matches(
            '#cross_selling .checkbox-round input[type="checkbox"]'
        )
    ) {
        var variantId = checkbox.value;
        var isChecked = checkbox.checked;

        // Record current scroll position
        var scrollContainer = document.querySelector(
            "#slider-cross-selling"
        );
        var currentScrollLeft = scrollContainer
            ? scrollContainer.scrollLeft
            : 0;

        // Save previous state for potential rollback
        var previousState = {
            checked: !isChecked,
            dataAdded: checkbox.getAttribute("data-added")
        };

        // OPTIMISTIC UPDATE: Apply UI changes immediately
        applyOptimisticUIState(checkbox, isChecked);
        updateCartCountOptimistic(isChecked ? 1 : -1);

        if (isChecked) {
            // Add to cart
            fetch("/cart/add.js", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    id: variantId,
                    quantity: 1,
                }),
            })
                .then((response) => {
                    if (!response.ok) {
                        throw new Error("Failed to add to cart");
                    }
                    return response.json();
                })
                .then((data) => {
                    // Success - UI already updated optimistically
                    // Trigger cart update event
                    if (
                        typeof window.theme !== "undefined" &&
                        window.theme.cart
                    ) {
                        window.theme.cart.updateCount();
                    }
                    document.dispatchEvent(
                        new CustomEvent("cart:updated")
                    );
                })
                .catch((error) => {
                    console.error(
                        "Error adding to cart:",
                        error
                    );
                    // Rollback optimistic updates
                    revertOptimisticUIState(checkbox, previousState);
                    updateCartCountOptimistic(-1);
                });
        } else {
            // Remove from cart - first get current cart to check quantity
            fetch("/cart.js")
                .then((response) => {
                    if (!response.ok) {
                        throw new Error("Failed to fetch cart");
                    }
                    return response.json();
                })
                .then((cart) => {
                    // Find the item in cart
                    var cartItem = cart.items.find(
                        (item) => item.id == variantId
                    );

                    if (!cartItem) {
                        // Item not in cart, UI already updated
                        return Promise.resolve();
                    }

                    // Calculate new quantity (current - 1)
                    var newQuantity = Math.max(0, cartItem.quantity - 1);

                    // Update cart with new quantity
                    return fetch("/cart/change.js", {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify({
                            id: variantId,
                            quantity: newQuantity,
                        }),
                    })
                        .then((response) => {
                            if (!response.ok) {
                                throw new Error("Failed to update cart");
                            }
                            return response.json();
                        })
                        .then(() => {
                            // Success - UI already updated optimistically
                            // Trigger cart update event
                            if (
                                typeof window.theme !== "undefined" &&
                                window.theme.cart
                            ) {
                                window.theme.cart.updateCount();
                            }
                            document.dispatchEvent(
                                new CustomEvent("cart:updated")
                            );
                        });
                })
                .catch((error) => {
                    console.error(
                        "Error removing from cart:",
                        error
                    );
                    // Rollback optimistic updates
                    revertOptimisticUIState(checkbox, previousState);
                    updateCartCountOptimistic(1);
                });
        }

        // Restore scroll position
        setTimeout(function () {
            if (scrollContainer) {
                scrollContainer.scrollLeft =
                    currentScrollLeft;
            }
        }, 0);
    }
});

// Allow clicking on the image to toggle checkbox
document
    .querySelectorAll("#cross_selling img")
    .forEach(function (img) {
        img.addEventListener("click", function (e) {
            // Record current scroll position
            var scrollContainer = document.querySelector(
                "#slider-cross-selling"
            );
            var currentScrollLeft = scrollContainer
                ? scrollContainer.scrollLeft
                : 0;

            var container = e.currentTarget.closest(
                ".scrollable_item"
            );
            var checkbox = container.querySelector(
                ".checkbox-round input"
            );

            checkbox.checked = !checkbox.checked;
            checkbox.dispatchEvent(new Event("change"));

            // Restore scroll position
            setTimeout(function () {
                if (scrollContainer) {
                    scrollContainer.scrollLeft =
                        currentScrollLeft;
                }
            }, 0);
        });
    });
